export default "__VITE_ASSET__CeLcIkm2__"